// v=51448918988081890391783963068
theme.library = v=51448918988081890391783963068;
theme.crr_library = localStorage.getItem('library') || '[]';
theme.strings = {
  inStock: "Vorrätig",
  outOfStock: "Nicht vorrätig",
  soldOut: "Ausverkauft",
  addToCart: "Zum Warenkorb hinzufügen",
  addedToCart: "Hat im Warenkorb",
  contact: "Kontakt",
  remove: "Entfernen",
  empty: "Dein Warenkorb ist zur Zeit leer",
  cartItem: "Du hast \u003cspan class='text-bold'\u003e(1 item)\u003c\/span\u003e in dienem Korb",
  cartItems: "Du hast \u003cspan class='text-bold'\u003e(2 items)\u003c\/span\u003e in deinem Korb",
  titleTotal: "Zwischensumme",
  noimage: "\/\/eyepixx.shop\/cdn\/shop\/t\/8\/assets\/noimage.gif?v=1495",
  infoButton: "Info",
  customButton: "Benutzerdefiniert",
  cdday: "Tage",
  cdhrs: "Stunden",
  cdmin: "Minuten",
  cdsecs: "Sekunden",
  no_shopping: "Es sind keine Versandarten für deinen Warenkorb oder deine Adresse verfügbar",
  nll_send: "Senden...",
  nll_error_mesenger: "Es konnte keine Verbindung zum Registrierungsserver hergestellt werden. Bitte versuchen Sie es später noch einmal.",
  nll_success_mesenger: "DANKEN SIE FÜR DIE ABONNIERUNG!\u003c\/br\u003eBenutze den \u003cspan class=\"code\"\u003e\u003c\/span\u003e Code, um einen Rabatt auf den ersten Kauf zu erhalten.",
  aspect_ratio: "1/1",
  search_dropdown_pages: "Seiten",
  search_dropdown_articles: "Von Molla",
  search_dropdown_no_results: "Deine Suche lieferte keine Ergebnisse."
};
theme.productStrings = {
  sizeGuide: "Anleitung zur Größe",
  addToCart: "Zum Warenkorb hinzufügen",
  preOrder: "Vorbestellung",
  selectOption: "Optionen auswählen",
  soldOut: "Ausverkauft",
  inStock: "Vorrätig",
  outOfStock: "Nicht vorrätig",
  unavailable: "Nicht verfügbar",
  onlyLeft: 'Nur <span>1</span> fehlt',
  onSale: 'Sale',
  stockMessage: ["Hurry! Only "," left in stock."],
  label_select: "Wähle ein",
  viewMoreVariants: "Mehr",
  addToWishlist: "Zum Wunschzettel hinzufügen",
  viewWishlist: "Zeige meinen Wunschzettel"
};
theme.function = {
  multiCurrency: false,
  autoCurrency: true,
  searchAjax: true,
  searchByCollection: false,
  searchAjaxTypes: "product,page,article",
  vrsgallery: true,
  quickshop: "true",
  quickview: false,
  fquickview: "false",
  use_am_popup: false,
  use_thumb_hidden_on_mb: false,
  productImgType: "normal",
  productOptionStyle: [{'name': "Color",'style': "combobox",'color_watched': true,'op_attach': false,'op_pre_select': false},{'name': "Size",'style': "combobox",'color_watched': false,'op_attach': true,'op_pre_select': false},{'name': "",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': false},{'name': "",'style': "combobox",'color_watched': false,'op_attach': false,'op_pre_select': false}],
  productGridOptionStyle: [{'name': "Color",'style': "circle _small",'color_watched': true, 'sw_style': "color"},{'name': "Size",'style': "list list_1",'color_watched': false, 'sw_style': "color"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "color"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "color"},{'name': "",'style': "list list_1",'color_watched': false, 'sw_style': "color"}],
  photoZoom: false,
  nll_ajax: false,
  ajax_cart: "none",
  sticky_icon_cart: null,
  cart_shipping_calculator: false,
  textInListShipping: "auf Bestellung über",
  product_delivery: {
    offSaturday: true,
    offSunday: true,
    offDays: ["23\/12\/****","24\/12\/****","01\/01\/****"],
    fromDate: 10,
    toDate: 15 
  }
};
theme.compare = {
  remove: "Entfernen"
};
theme.gadget = {
  cookies_infor: false,
  newsletter_popup: false,
  shipTo: true
};

theme.suggest = {
  enable: false,
  collection_opj: "",
  delay_time: 7000,
  show_time: 7600,
  use_fake_location: true,
  arr_fake_location: ["Melbourne, Australia","Washington","Nevada"]
};
theme.extensions = {
  ktToolsCss: '//eyepixx.shop/cdn/shop/t/8/assets/ktTools.scss.css?v=22945105168615461471783963068',
  ktToolsJs: '//eyepixx.shop/cdn/shop/t/8/assets/ktTools.js?v=23518685763435140231783963068',
  ktToolsSlideshowJs: '//eyepixx.shop/cdn/shop/t/8/assets/ktTools.slideshow.js?v=100870860377929872381784035680',
  adminThemeTool: '//eyepixx.shop/cdn/shop/t/8/assets/adminThemeTool.scss.css?v=26032429354608457171783963068',
  ktToolsSettingsPreset: '//eyepixx.shop/cdn/shop/t/8/assets/settings_preset.js?v=1495'
}

const firstLink = document.getElementsByTagName("link")[0];
const headDocument = document.head;
const bodyDocument = document.body;
var $ = $jqMolla;

if (theme.crr_library.length == 0) {
  localStorage.setItem('library','[]');
}

window._handleize = function(str){
  str = str.toLowerCase().replace(/'|"|\(|\)|\[|\]/g, "").replace(/\W+/g, "-")
  return str.replace(/^-+|-+$/g, "")
}
window._snakeCase = function(str){
  str = str.toLowerCase().replace(/'|"|\(|\)|\[|\]/g, "").replace(/\W+/g, "_")
  return str.replace(/^-+|-+$/g, "")
}

"undefined" == typeof KT && (KT = {});
KT.checkVersion = function(name_item){
  name_item = name_item.split('/')[name_item.split('/').length - 1];
  var version = false;
  if(!localStorage.getItem(name_item)){
    version = true; 
  }
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
      version = true;
    }
  } else if(libs_ver.findIndex(function(obj){ return obj.name == name_item}) === -1){
    version = true;
  }
  return version; 
}
KT.pushVersion = function(name_item){
  var libs_ver = JSON.parse(theme.crr_library);
  if (libs_ver.length && libs_ver.findIndex(function(obj){ return obj.name == name_item}) !== -1) { 
    var objIndex = libs_ver.findIndex(function(obj){ return obj.name == name_item});
    if (parseFloat(libs_ver[objIndex].ver) !== theme.library) {
      libs_ver[objIndex].ver = theme.library;
      localStorage.setItem('library',JSON.stringify(libs_ver));
    }
  }
  else {
    var obj = {
      name : name_item,
      ver : theme.library
    }
    libs_ver.push(obj);
    localStorage.setItem('library',JSON.stringify(libs_ver));
  }
  theme.crr_library = localStorage.getItem('library') || '[]';
}
KT.loadScript = function(id, callback) {
  let css_url = "";
  let js_url = "";
  let done = false;
  // var file_name_css = '';
  if($('#'+id).length){
    checkExists(id, js_url)
  }
  else {
    if(id == 'magnific-popup' && $('#magnific-popup-css').length <= 0){
      css_url = "//eyepixx.shop/cdn/shop/t/8/assets/magnific-popup.min.css?v=57525974320827922071783963068";
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/jquery.magnific-popup.min.js?v=184369421263510081681783963068";
    }
    else if(id == 'threesixty' && $('#threesixty-css').length <= 0){
      css_url = "//eyepixx.shop/cdn/shop/t/8/assets/threesixty.min.css?v=110917158222743342331783963068";
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/threesixty.min.js?v=82311723604142068331783963068";
    }
    else if(id == 'photo-swipe' && $('#photo-swipe-css').length <= 0){
      css_url = "//eyepixx.shop/cdn/shop/t/8/assets/photoswipe-ui.min.css?v=50182594455179234001783963068";
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/photoswipe-ui.min.js?v=89145670203526742621783963068";
    }
    else if(id == 'YTPlayer'){
      css_url = "//eyepixx.shop/cdn/shop/t/8/assets/jquery.mb.YTPlayer.min.css?v=59914316629707384691783963068";
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/jquery.mb.YTPlayer.min.js?v=127366606670431650381783963068";
    }
    else if(id == 'swiper'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/swiper.min.js?v=169146728960025539401783963068";
    }
    else if(id == 'pjax'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/jquery.pjax.min.js?v=96510263879411166301783963068";
    }
    else if(id == 'imagesloaded'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/imagesloaded.pkgd.min.js?v=147859183389955144291783963068";
    }
    else if(id == 'isotope'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/isotope-plus.pkgd.min.js?v=139088845446234680461783963068";
    }
    else if(id == 'instafeed'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/instafeed.min.js?v=90032470946696484961783963068";
    }
    else if(id == 'countdown'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/jquery.countdown.min.js?v=44111188705250456101783963068";
    }
    else if(id == 'countto'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/jquery.countTo.min.js?v=148382760188409556611783963068";
    }
    else if(id == 'moment'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/moment.min.js?v=96302747854271246571783963068";
    }
    else if(id == 'momentlocale'){
      if (shopLocale === 'en') {handleLoad(); return}
      js_url = "//cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/locale/"+shopLocale+".js";
    }
    else if(id == 'zoom'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/jquery.zoom.min.js?v=127655014540499679121783963068";
    }
    else if(id == 'parallax'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/jquery.parallax_mousemove.js?v=79184343061227765141783963068";
    }
    else if(id == 'tippy'){
      js_url = "//eyepixx.shop/cdn/shop/t/8/assets/tippy-bundle.iife.min.js?v=119878756178377760041783963068";
    }
    else if(id == 'color_sw'){
      css_url = "//eyepixx.shop/cdn/shop/t/8/assets/swatch-color.css?v=78580961369041399831783963068";
    }
    else if(id == 'animate'){
      css_url = "//eyepixx.shop/cdn/shop/t/8/assets/animate.min.css?v=20349278028107590831783963068";
    }
    else if(id == 'adminThemeCss'){
      css_url = "//eyepixx.shop/cdn/shop/t/8/assets/adminThemeTool.scss.css?v=26032429354608457171783963068";
    }
    done = false;
    ajaxLoad(id, css_url, js_url);
  }
  function ajaxLoad(name, css_url, js_url){
    if(css_url !== ''){
      var scr_css = document.createElement('link');
      scr_css.type = 'text/css';
      scr_css.rel = "stylesheet";
      scr_css.id = name+'-css';
      scr_css.href = css_url;
      scr_css.onerror = function() {
        alert("Error loading css " + this.href);
      };
      headDocument.insertBefore(scr_css, firstLink);
    }
    if(js_url !== ''){
      var scr_js = document.createElement('script');
      scr_js.type = 'text/javascript';
      scr_js.async = true;
      scr_js.src = js_url;
      scr_js.id = name;
      scr_js.onload = checkExists(name, js_url);
      scr_js.onerror = function() {
        alert("Error loading js " + this.src);
      };
      bodyDocument.appendChild(scr_js);
    }
  }
  function checkExists(id, js_url){
    var callbackTimer = setInterval(function() {
      if (id == 'swiper' && typeof Swiper === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'owl-carousel' && typeof $.fn.owlCarousel === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'slick-slide' && typeof $.fn.slick === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'moment' && typeof moment === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'imagesloaded' && typeof $.fn.imagesLoaded === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'isotope' && typeof $.fn.isotope === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'YTPlayer' && typeof jQuery.fn.YTPlayer === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'parallax' && typeof $.fn.mouseMove === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countdown' && typeof $.fn.countdown === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'countto' && typeof $.fn.countTo === 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'magnific-popup' && typeof $.fn.magnificPopup == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'instafeed' && typeof Instafeed == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'momentlocale' && moment.locale() == shopLocale){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if (id == 'zoom' && typeof $.fn.zoom == 'function'){
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'pjax' && typeof $.fn.pjax == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'photo-swipe' && typeof PhotoSwipe == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'threesixty' && typeof $jq == 'function' && typeof $jq.fn.ThreeSixty == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
      if(id === 'tippy' && typeof tippy == 'function') {
        handleLoad()
        clearInterval(callbackTimer);
        return true;
      }
    }, 100);
  }
  function handleLoad() {
    if (!done) {
      done = true;
      // console.log(js_url)
      callback(js_url, "ok");
    }
  }
}